export function isStandaloneWebApp() {
  // @ts-ignore
  const isInWebAppiOS = window.navigator.standalone === true;
  const isInWebAppChrome = window.matchMedia('(display-mode: standalone)').matches;

  return isInWebAppiOS || isInWebAppChrome;
}
